import React from "react";
import { Navigate } from "react-router-dom";

import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import VerifyEmail from "../pages/Authentication/VerifyEmail";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";
import EventSongs from "../pages/Events/EventSongs";
import UserList from "../pages/User/UserList";
import User from "../pages/User/UserDetails";
import OnePage from "../pages/Landing/OnePage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Faqs from "../pages/Faqs/Faqs";
import ProfileSettings from "../pages/Profile/Settings/ProfileSettings";
import TipsListPage from "../pages/Tips/TipsList";
import SongLibraries from "../pages/SongLibraries/SongLibraries";
import LibraryDetail from "../pages/SongLibraries/LibraryDetail";


const authProtectedRoutes = [
  { path: "/admin/event/:eventId", component: <EventSongs /> },
  { path: "/admin/user", component: <UserList /> },
  { path: "/admin/user/:userId", component: <User /> },
  { path: "/admin/profile", component: <ProfileSettings /> },
  { path: "/admin/tips", component: <TipsListPage /> },
  { path: "/admin/song-libraries/:id", component: <LibraryDetail /> },
  { path: "/admin/song-libraries", component: <SongLibraries /> },
  { path: "/admin/help", component: <Faqs /> },
  // { path: "/profile", component: <UserProfile /> },
  // { path: "/events/:eventId", component: <EventSongs /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "*", component: <Navigate to="/admin/login" /> },
];

const publicGeneralRoutes = [
  // Authentication Page
  { path: "/admin/logout", component: <Logout /> },
  { path: "/admin/login", component: <Login /> },
  { path: "/", component: <OnePage /> },
  { path: "/verify-email", component: <VerifyEmail />},
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  // { path: "/auth-404-cover", component: <Cover404 /> },
  // { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  // { path: "/auth-offline", component: <Offlinepage /> },
  //
  // { path: "/events/:eventId", component: <EventDetail /> },
];

const publicRoutes = [
  { path: "/event/:eventId", component: <EventSongs /> },
];

export { authProtectedRoutes, publicGeneralRoutes, publicRoutes };
